import { storeToRefs } from "pinia";
import { useAuth } from "@/stores/AuthStore";

export const superAdminGuard = (to, from, next) => {
    const { isSuperAdmin } = storeToRefs(useAuth());

    if (isSuperAdmin.value) {
        return next();
    }

    return next("");
};
